<script lang="ts">
  import { yPct } from '../../utils/chart';

  // Bars draws a chart's bars in its overlay (spec 010 FR-033): each
  // centered at at, 0 to 1 across, from base up to v, as wide as width of
  // the plot allows up to 24 px, with a rounded top. hollow outlines a bar,
  // as an estimated load is, and picked outlines the selected one.
  interface Bar {
    at: number;
    v: number;
    base?: number;
    color: string;
    hollow?: boolean;
    opacity?: number;
  }
  let { bars, width, lo, hi, picked = null }: { bars: Bar[]; width: number; lo: number; hi: number; picked?: number | null } = $props();
</script>

{#each bars as b, i (i)}
  {@const top = yPct(Math.max(b.v, b.base ?? lo), lo, hi)}
  {@const bottom = yPct(b.base ?? Math.max(lo, 0), lo, hi)}
  <span class="absolute rounded-t-[3px] pointer-events-none" aria-hidden="true"
    style="left: {b.at * 100}%; width: min({width * 100}%, 24px); transform: translateX(-50%); bottom: {100 - bottom}%; height: max(2px, {bottom - top}%);
      {b.hollow ? `box-shadow: inset 0 0 0 1.5px ${b.color};` : `background: ${b.color};`} opacity: {b.opacity ?? 1};
      {picked === i ? 'outline: 2px solid var(--theme-text); outline-offset: 1px;' : ''}"></span>
{/each}
